import { Shippings } from '@app/pages/checkout-app/types';
import { useAppContext } from '@app/react-common/AppContext';
import { ExpandableText } from '@app/react-common/components/expandable-text/ExpandableText';
import { currencyStrToSign } from '@utils/string-utils';
import React, { useState, useEffect } from 'react';

export interface RatesPricesComponentProps {
  shipping: Shippings;
}

export const DisplayRatesComponent = ({ shipping }) => {
  const LiveRateMethodCategories = ['DOMESTIC_LIVE_RATE', 'INTERNATIONAL_LIVE_RATE'];
  const { shop$ } = useAppContext();

  const [rates, setRates] = useState([]);
  const [currency, setCurrency] = useState<string>('');

  useEffect(() => {
    const subscription = shop$.subscribe((shop) => {
      if (shop) {
        setCurrency(currencyStrToSign(shipping?.methodCurrency || shop?.metadata?.currency));
      }
    });
    const { minOrderPriceRange, maxOrderPriceRange, rate, additionalPriceRanges, percentageOfCarrierCost, flatAmount } =
      shipping;

    let ratePrices = [];

    if (
      shipping.shippingMethod?.category === 'DOMESTIC_LIVE_RATE' ||
      shipping.shippingMethod?.category === 'INTERNATIONAL_LIVE_RATE'
    ) {
      const liveRatePrice: any = {
        rate: 'Live rate',
      };

      if (percentageOfCarrierCost > 0) {
        liveRatePrice.percentOfShippingCharge = percentageOfCarrierCost + '%';
      }

      if (flatAmount > 0) {
        liveRatePrice.flatAmount = currency + flatAmount;
      }

      setRates([liveRatePrice]);
    } else {
      ratePrices = [{ rate, minOrderPriceRange, maxOrderPriceRange }];

      if (additionalPriceRanges?.length) {
        ratePrices = ratePrices.concat(additionalPriceRanges);
      }

      setRates(
        ratePrices.map((r) => {
          const maxCartValue =
            !r.maxOrderPriceRange || +r.maxOrderPriceRange === 0 ? 'No limit' : currency + r.maxOrderPriceRange;
          const minCartValue = currency + (!r.minOrderPriceRange ? 0 : r.minOrderPriceRange);

          return {
            rate: currency + r.rate,
            minCartValue,
            maxCartValue,
          };
        }),
      );
    }
    return () => {
      subscription.unsubscribe();
    };
  }, [shipping, currency]);

  return (
    <div>
      {LiveRateMethodCategories.includes(shipping?.shippingMethod?.category) ? (
        <div className="font12">
          <div>{rates[0].rate}</div>
          {rates[0].percentOfShippingCharge && (
            <div>
              shipping charge:
              <div className="col">{rates[0].percentOfShippingCharge}</div>
            </div>
          )}
          {rates[0].flatAmount && (
            <div>
              flat:
              <div className="col">{rates[0].flatAmount}</div>
            </div>
          )}
        </div>
      ) : (
        <>
          {rates.length === 1 ? (
            <div className="font12">
              <div>Rate: {rates[0].rate}</div>
              <div>Cart value:</div>
              <div>
                {rates[0].minCartValue} - {rates[0].maxCartValue}
              </div>
            </div>
          ) : (
            <>
              <ExpandableText
                title={'rates'}
                rows={[].concat(
                  ...rates.map((rate, index) => {
                    const all_rows = [];
                    all_rows.push(`Rate: ${rate.rate}`);
                    all_rows.push(`Cart value:`);
                    all_rows.push(`${rate.minCartValue} - ${rate.maxCartValue}`);
                    return all_rows;
                  }),
                )}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};
